"use client"

import CTA from "@/components/Category/CTA";
import ToFAQ from "@/components/Category/ToFAQ";
import { site } from "@/data/default";
import { ReactNode } from "react";

export const cameraContents: ReactNode = (
  <>
    <h2 className="text-xl font-bold mb-2">Sewa Kamera Terdekat untuk Hasil Pro Tanpa Modal Jutaan</h2>
    <p className="mb-4">
      Lagi cari <strong>sewa kamera terdekat</strong> karena butuh hasil yang tajam, jernih, dan sinematik? Gak perlu beli gear mahal atau tunggu tabungan cukup. Sekarang, cukup klik, unit langsung meluncur ke lokasi kamu. DSLR Canon,
      mirrorless Sony, kamera vlog, bahkan kamera aksi semuanya bisa kamu dapetin <em>on-demand</em>, lengkap sama bonusnya!
    </p>
    <ul className="space-y-4 mb-6">
      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h3 className="font-semibold text-lg mb-2">Temukan Sewa Kamera Terdekat di Kotamu</h3>
        <p className="text-sm">
          Dari Jakarta, Bandung, sampai Makassar kami punya jaringan mitra luas. Kamu tinggal cari <strong>kamera sewaan terdekat</strong>, langsung dapat lokasi, estimasi harga, dan stok real-time. Bisa dikirim hari ini juga, tanpa ribet
          jemput.
        </p>
      </li>
      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h3 className="font-semibold text-lg mb-2">Pilihan Kamera Lengkap: DSLR, Mirrorless, hingga Action Cam</h3>
        <p className="text-sm">
          Butuh kamera Canon EOS buat wedding? Sony A7 buat video cinematic? Atau GoPro buat traveling? Semuanya tersedia. Tinggal pilih berdasarkan <strong>harga sewa kamera</strong>, spesifikasi, dan tipe favoritmu.
        </p>
      </li>
      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h3 className="font-semibold text-lg mb-2">Diantar Kilat, Siap Pakai Langsung</h3>
        <p className="text-sm">Setiap unit dikalibrasi, baterai full, memory card sudah dipasang. Bahkan bisa request tambahan tripod, mic, atau lighting. Sewa kamera harian, mingguan, atau bulanan? Semua bisa diatur tanpa drama.</p>
      </li>
      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h3 className="font-semibold text-lg mb-2">Harga Sewa Kamera Terjangkau + Banyak Bonusnya</h3>
        <p className="text-sm">Mulai dari Rp 50.000-an per hari. Booking 3 hari? Dapat diskon. Sewa 1 minggu? Dapat tas & extra SD card. Bawa teman? Dapat cashback. Harga murah, tanpa murahan.</p>
      </li>
      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h3 className="font-semibold text-lg mb-2">Booking Fleksibel, Gak Harus Rencana Jauh-Jauh Hari</h3>
        <p className="text-sm">Mau sewa kamera hari ini karena job dadakan? Atau buat event bulan depan? Semua bisa. Kamu tinggal pilih tanggal, kami yang atur semuanya. Bahkan bisa ubah durasi di tengah sewa.</p>
      </li>
    </ul>
    <h2 className="text-xl font-bold mb-3">Sewa Kamera Terdekat Bisa Antar-Jemput Gratis*</h2>
    <p className="mb-4">Untuk area Jabodetabek dan kota besar lain, kami sediakan layanan <strong>antar-jemput kamera sewaan</strong>. Tinggal duduk manis, unit datang ke pintu. Pas sewa selesai? Kami jemput lagi. Gak sempat? Gak masalah.</p>
    <h2 className="text-xl font-bold mb-3">Durasi Fleksibel: Harian, Mingguan, Bulanan</h2>
    <p className="mb-4">Produksi pendek? Sewa 1 hari cukup. Shooting serial YouTube? Sewa bulanan bisa banget. Durasi kamu yang atur, tanpa khawatir penalti atau sistem ribet.</p>
    <h2 className="text-xl font-bold mb-3">Garansi Teknis & Support Real-Time</h2>
    <p className="mb-4">Kamera ngadat di tengah job? Tenang. Ada garansi unit dan tim support standby. Bahkan bisa kirim pengganti cepat kalau masalah gak bisa diselesaikan via chat. Ini bukan rental biasa ini partner produksimu.</p>

    <CTA
      title="Siap Moto & Shooting Bosku?"
      description="🚚 Butuh sewa kamera terdekat sekarang juga? Chat tim kami sekarang. <br />Kapan pun, di mana pun, selama unit ready, kami kirim hari itu juga."
      buttonText="Booking Kamera Sekarang"
      onClick={() => {
        window.open(
          `https://wa.me/${site.whatsapp}?text=Halo%2C%20saya%20ingin%20booking%20kamera.%20Lokasi%20dan%20tanggal%20sudah%20siap.`,
          "_blank"
        );
      }}
    />

    <ToFAQ
      category="Kamera"
    />

  </>
);
